import React,{Component} from 'react';
import {Collection, Row, Col, CardPanel, Button} from 'react-materialize';
import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';

import {injectIntl, intlShape} from 'react-intl';


class Running extends Component{

    constructor(props){
        super(props);
        this.state={ques:1,score:0,isLoaded:false,items:[]};



    }
    componentDidMount() {
        const intl= this.props.intl;
        intl.locale === "en" ?

            fetch("https://api.npoint.io/2af00ce1cb98082d42fc")
                .then(res => res.json())
                .then(
                    (result) => {
                        this.setState({
                            isLoaded: true,
                            items: result
                        });
                    },

                    (error) => {
                        this.setState({
                            isLoaded: false,
                        });
                    }
                ):

        fetch("https://api.npoint.io/65c023dea477b5877d0e")
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoaded: true,
                        items: result
                    });
                },

                (error) => {
                    this.setState({
                        isLoaded: false,
                    });
                }
            )


    }
    checkAnswer(value){
        if(value==="true"){
            this.setState((prevState)=>{
                return {ques:prevState.ques+1,score:prevState.score+10};
            });
        }
        else{
            this.setState((prevState)=>
                {
                    return {ques:prevState.ques+1};
                }
            )
        }
    }
    renderQuestions(){
        return(
            <div>
                <Collection header={this.state.items[this.state.ques-1]["question"]} >
                    {
                        this.state.items[this.state.ques-1]["answers"].map(ans =>(<div className={"collection"}>  <a className={"collection-item"} href="#" onClick={()=>this.checkAnswer(ans.correct)}>{ans.value}</a> </div>))
                    }
                </Collection>
            </div>

        )
    }
    renderFinish(){
        return(
            <div>
                <Row>
                    <Col s={12} m={2} offset={"m5"} >
                        <h1 className="teal-text text-lighten-2">Score</h1>
                        <CardPanel className="teal lighten-2 black-text" title="Score">
                            <span className="header center white-text text-lighten-2">{this.state.score}</span>
                        </CardPanel>
                    </Col>
                </Row>
                <Button waves='light' onClick={()=>this.props.handleState('running')}>Voltar</Button>
            </div>
        )
    }
    render(){
        const  len=this.state.items.length;
        console.log(len);
        if(this.state.isLoaded){
            return (
                <div>
                    <Row>
                        <Col s={12} m={2}>
                            <h5 className={"question"} align="center"><FormattedMessage id={"question"} defaultMessage={"Questão"}/></h5>
                            <CardPanel className="blue darken-1 black-text" title="Question" align={"center"}>
                                <span className="header center white-text text-lighten-2"> {this.state.ques} </span>
                            </CardPanel>
                        </Col>

                        <Col s={12} m={2} offset={"m8"} >
                            <h5 className={"score"} align="center">Score</h5>
                            <CardPanel className="blue darken-1 black-text" title="Score" align={"center"}>
                                <span className="header center white-text text-lighten-2">{this.state.score}</span>
                            </CardPanel>
                        </Col>
                    </Row>
                    {
                        this.state.ques <= len ?this.renderQuestions():this.props.handleState('finished',this.state.score)
                    }

                </div>
            )
        }
        else{
            return <div>  </div>
        }

    }
}

export default injectIntl(Running);